import { ImagesService } from './../../service/images.service';
import { ClassificationResultDataModel } from './../../model/classificationDetection.model';
import { Component, OnInit, ViewChild, ElementRef, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { RoiService } from '../../service/roi.service';
import { Damage, DamageAnalysis } from '../../model/damage.model';
import { ReportService } from '../../service/report.service';
import { Report } from '../../model/report.model';
import { DamageService } from '../../service/damage.service';
import { Subscription } from 'rxjs';
import { TchekService } from '../../service/tchek.service';
import { ParametersService } from '../../service/parameters.service';
import { TchekImage } from '../../model/image';
const parse: typeof Parse = require('parse');

declare const $: any;

@Component({
  selector: 'app-classificationImageToggleComponent',
  templateUrl: './classificationImageToggle.component.html',
  styleUrls: ['./classificationImageToggle.component.less'],
  animations: [
    trigger('openClose', [
      state('open', style({
        right: '0px'
      })),
      state('closed', style({
        right: '-28vw'
      })),
      transition('open => closed', [
        animate('350ms ease-out')
      ]),
      transition('closed => open', [
        animate('350ms ease-out')
      ]),
    ]),
  ]
})
export class classificationImageToggleComponent implements OnInit {
  @ViewChild('drawerContent') drawerContent: ElementRef;
  @Input() tchekId: string;
  @Input() cameraName: string;
  @Input() currentImage: TchekImage;
  @Input() currentMode: string;
  @Output() itemClick = new EventEmitter<any>();
  @Output() damageSelected: EventEmitter<Damage>;
  @Output() damageDeleted: EventEmitter<Damage>;
  isOpen: boolean;
  autoRois: any;
  damages: any;
  report: Report;
  subscription: Subscription[];
  countNbr: number;
  canDetection = false
  constructor(
    private readonly _parametersService: ParametersService,
    private readonly _roiService: RoiService,
    private readonly _reportService: ReportService,
    private readonly _damageService: DamageService,
    private readonly _tchekService: TchekService
  ) {
    this.subscription = []
    this.isOpen = false;
    this.canDetection = this._parametersService.canDetection;
    this.damages = [];
    this.damageSelected = new EventEmitter<Damage>();
    this.damageDeleted = new EventEmitter<Damage>();

    this.isOpen = true
  }

  ngOnInit() {
  }


  open() {
    this.isOpen = true;
    $('#da').css('height', 40 + 'px')

  }

  close() {
    this.isOpen = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/element/classificationImageToggle/classificationImageToggle.component.ts